
import LoginRequired from '@/components/FileViewer/LoginRequired.vue'
import CopyButton from '@/components/FileViewer/CopyButton.vue'
import ShareIcon from '@/components/FileViewer/Icons/ShareIcon.vue'
import SectionLabel from '@/components/FileViewer/SectionLabel.vue'
import LinkIcon from '@/components/FileViewer/Icons/LinkIcon.vue'
import ChevronLeftIcon from '@/components/FileViewer/Icons/ChevronLeftIcon.vue'
import ChevronRightIcon from '@/components/FileViewer/Icons/ChevronRightIcon.vue'
import LockIcon from '@/components/FileViewer/Icons/LockIcon.vue'
import CountdownTimer from '@/components/FileViewer/CountdownTimer.vue'
import Modal from './Modal.vue'
import NotificationsIcon from './Icons/NotificationsIcon.vue'
import PencilSquareIcon from './Icons/PencilSquareIcon.vue'
import DispatchEventUtils from './Mixins/DispatchEventUtils.js'

export default {
    name: 'FileTimeline',
    components: {
        CountdownTimer,
        LockIcon,
        ChevronLeftIcon,
        ChevronRightIcon,
        LinkIcon,
        LoginRequired,
        PencilSquareIcon,
        NotificationsIcon,
        Modal,
        CopyButton,
        ShareIcon,
        SectionLabel
    },
    mixins: [DispatchEventUtils],
    props: {
        fileTimeline: {
            type: Array,
            default: () => []
        },
        meta: {
            type: Object,
            default: () => ({})
        }
    },
    inject: ['isLogged'],
    data () {
        return {
            modalData: null
        }
    },
    computed: {
        items () {
            const fakeData = [
                {
                    'section_title': 'الباب 6084',
                    'title': 'القسم 32629',
                    'content': 'القسم 32629',
                    'formattedDate': '1445 محرم 2',
                    'link': null,
                    'type': 'history'
                },
                {
                    'section_title': 'الباب 2324',
                    'title': 'القسم 2554',
                    'content': 'القسم 2321',
                    'formattedDate': '1444 صفر 2',
                    'link': null,
                    'type': 'history'
                },
                {
                    'section_title': 'الباب 2324',
                    'title': 'القسم 32629',
                    'content': 'القسم 32629',
                    'formattedDate': '1448 رجب 2',
                    'link': null,
                    'type': 'future'
                },
                {
                    'section_title': 'الباب 6084',
                    'title': 'القسم 32629',
                    'content': 'القسم 32629',
                    'formattedDate': '1445 محرم 2',
                    'link': null,
                    'type': 'history'
                },
                {
                    'section_title': 'الباب 2324',
                    'title': 'القسم 2554',
                    'content': 'القسم 2321',
                    'formattedDate': '1444 صفر 2',
                    'link': null,
                    'type': 'history'
                },
                {
                    'section_title': 'الباب 2324',
                    'title': 'القسم 32629',
                    'content': 'القسم 32629',
                    'formattedDate': '1448 رجب 2',
                    'link': null,
                    'type': 'future'
                }
            ]
            return this.fileTimeline.length > 0 ? this.fileTimeline : fakeData
        },
        isUnavailable () {
            return !(this.fileTimeline.length > 0)
        }
    },
    methods: {
        isLastItem (index, array) {
            return index === array.length - 1
        },
        showModal (item) {
            this.modalData = item
        },
        showShare (item) {
            const data = item.type === 'future' ? item : {
                title: item.section_title,
                id: item.section_id,
                item: {
                    id: item.id
                }
            }
            this.dispatch('FileViewer', 'show-share', { data, type: item.type, meta: this.meta })
        }
    }
}
